import React, { useState } from 'react';
import QrReader from "react-qr-reader";
import { systemCode, xs_languageCode } from '../..';
import { iOS, isSafari } from '../../data/util/browserDetector';
import { getBaseURL } from '../../data/utils/getBaseURL';
import { getCheckbetPage } from '../../data/utils/getCheckbetPage';
import { REGEX_URL } from '../../data/utils';
import { getLabel } from '../../data/labels';
import { useCheckTicket } from './CheckTicketContext';
import { ReactComponent as InfoIcon } from '../../icons/icon_info_markets.svg';
import { vibrate } from '../../utils';
import { openPopup } from '../../data/sport-utils';

export default function QRCodeScanner() {
    const checkTicket = useCheckTicket();
    
    const [isError, setIsError] = useState(false);
    function handleError(err) {
        setIsError(true);
        console.error(err);
    }

    if (isError) {
        return (
            <div className="h-10 m-2 grid grid-cols-12 items-center bg-cs7 text-sx text-cs6 rounded">
                <InfoIcon className="col-start-1 col-end-3 h-12 w-12 fill-cs6" />
                <span className="col-start-3 col-end-13 text-fs2 font-bold text-cs6">{getLabel('check_ticket.not_supported')}</span>
            </div>
        );
    }

    function handleScan(data) {
        if (data) {
            vibrate();
            if (REGEX_URL.test(data)) {
                checkTicket.setCheckbetUrl(data);
                openPopup(data,getLabel('general.checkbet'), 400, 800);
            } else {
                const ios = isSafari || iOS();
                if (ios) {
                    checkTicket.setTicketId(data);
                } else {
                    const baseURL = getBaseURL();
                    const checkbetPage = getCheckbetPage(true);
                    const ticketUrl = `${baseURL.replace('xsport_desktop', 'xsport_mobile')}${checkbetPage}?ticket=${data}&system_code=${systemCode}&language=${xs_languageCode}`;
                    checkTicket.setCheckbetUrl(ticketUrl);
                    openPopup(ticketUrl,getLabel('general.checkbet'), 400, 800);
                }
            }
        }
    }

    const constraints = {facingMode: "environment", width:{exact: 900}, height:{exact: 480}};

    return (
        <>
            {checkTicket.scannerStarted &&
                <div>
                    <QrReader
                        delay={300}
                        onError={handleError}
                        onScan={handleScan}
                        onLoad={() => {}}
                        constraints={constraints}
                    />
                </div>
            }
        </>
      );
}
